module.exports = __webpack_public_path__ + "ac3e47a0769207975cb2ef2813bc567f.pdf";